import { css } from '@ni/fast-element';
import {
    buttonAppearanceVariantStyles,
    styles as buttonStyles
} from '../patterns/button/styles';

export const styles = css`
    ${buttonStyles}
    ${buttonAppearanceVariantStyles}
`;
